// Initial state of Construct Table
export const initConstructTableState = {
    skip: 0,
    take: 20,
    sort: [
        {
            field: "appointmentTime",
            dir: "asc",
        },
    ],
    filter: null,
};

export const  initConstructTableCols ={
      patientName: true,
      insurance: true,
      eligibility: true,
      provider: true,
      time: true,
      procedures: true,
      healthRisk: true,
      economicWellBeing: true,
      medicalCondition: true,
      arBalance: true,
      treatmentPlan: true,
      patient: true,
      owner: true,
      type: true,
      lastWeight: true,
      compliance: true,
      petWellBeing: true,
  }

